{
  "dashboard": {
    "label": "Dashboard",
    "route": "/app/dashboard",
    "parent": ""
  },
  "my-profile": {
    "label": "My Profile",
    "route": "/app/my-profile",
    "parent": "dashboard"
  },
  "my-profile/terms-and-conditions": {
    "label": "Terms & Conditions",
    "route": "/app/my-profile/terms-and-conditions",
    "parent": "my-profile"
  },
  "my-profile/faqs": {
    "label": "FAQs",
    "route": "/app/my-profile/faqs",
    "parent": "my-profile"
  },
  "my-profile/faqs/:faqUID": {
    "label": ":faqUID",
    "route": null,
    "parent": "my-profile/faqs"
  },
  "contact-us": {
    "label": "Contact Us",
    "route": "/contact-us",
    "parent": "my-profile"
  },
  "contact-us/form": {
    "label": "Submit your query",
    "route": "/contact-us/form",
    "parent": "contact-us"
  },
  "my-profile/update": {
    "label": "Update details",
    "route": "/app/my-profile/update",
    "parent": "my-profile"
  },
  "my-profile/marketing-preferences": {
    "label": "Preferences",
    "route": "/app/my-profile/marketing-preferences",
    "parent": "my-profile"
  },
  "my-profile/howden-for-students": {
    "label": "About Howden for Students",
    "route": "/app/my-profile/about-howden-for-students",
    "parent": "my-profile"
  },
  "my-profile/privacy-notice": {
    "label": "Privacy and Cookie Policy",
    "route": "/app/my-profile/privacy-notice",
    "parent": "my-profile"
  },
  "my-profile/app-terms-of-use": {
    "label": "App Terms of Use",
    "route": "/app/my-profile/app-terms-of-use",
    "parent": "my-profile"
  },
  "my-insurance": {
    "label": "My Insurance",
    "route": "/app/my-insurance",
    "parent": "dashboard"
  },
  "my-insurance/update": {
    "label": "Update details",
    "route": "/app/my-insurance/update",
    "parent": "my-insurance"
  },
  "protect-and-save": {
    "label": "Protect & Save",
    "route": "/app/protect-and-save",
    "parent": "dashboard"
  },
  "protect-and-save/:productUID": {
    "label": ":productUID",
    "route": null,
    "parent": "protect-and-save"
  },
  "refer-a-friend": {
    "label": "Refer a friend",
    "route": "/app/refer-a-friend",
    "parent": "dashboard"
  },
  "wellbeing": {
    "label": "Wellbeing",
    "route": "/app/wellbeing",
    "parent": "dashboard"
  },
  "student-life": {
    "label": "Student Life",
    "route": "/app/student-life",
    "parent": "dashboard"
  },
  "international-student": {
    "label": "International Students",
    "route": "/app/international-student",
    "parent": "dashboard"
  },
  "international-student/make-a-claim": {
    "label": "Make a claim",
    "route": "/app/international-student/make-a-claim",
    "parent": "international-student"
  },
  "international-student/contact-us": {
    "label": "Contact us",
    "route": "/app/international-student/contact-us",
    "parent": "international-student"
  },
  "international-student/policy-summary": {
    "label": "Policy Summary",
    "route": "/app/international-student/policy-summary",
    "parent": "international-student"
  },
  "jobs-and-careers": {
    "label": "Jobs and Careers",
    "route": "/app/jobs-and-careers",
    "parent": "dashboard"
  }
}
